// extracted by mini-css-extract-plugin
export default {"tickets":"tickets_tickets__SFTYm","hidden":"tickets_hidden__G2Ecy","ticketPagination":"tickets_ticketPagination__-jrqC"};